import { useNavigate } from "react-router-dom";
import Chevronleft from "../../assets/svgs/chevron-left";
import H2 from "../typography/H2";

interface LeftArrowTopHeaderProps {
  title: string;
  backPath?: string | number;
  className?:string;
  handleSubmit?:()=>void;
  backState?: object;
  onCancel?: () => void;
}

export default function LeftArrowTopHeader({title,backPath,className="" ,handleSubmit, backState, onCancel}: LeftArrowTopHeaderProps) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    if (typeof backPath === "number") {
      navigate(backPath);
    } else {
      navigate(backPath, backState ? { state: backState } : undefined);
    }
  if(!backPath){
      handleSubmit();
    }
  };

  return (
    <div className={`tenants-header ${className}`}>
      <button
        type="button"
        className="btn-Goback"
        onClick={handleBackClick}
        aria-label={`Go back to ${title}`}
      >
        <div className="btn-left-arrow-circle-icon">
          <Chevronleft width="28" height="28" className="iconStyleWithWhiteFilter" />
        </div>
      </button>
      <H2 text={title} />
    </div>
  );
}